import { Component, Mixins, Watch } from "vue-property-decorator";
import ListDropdown from "@/components/list-dropdown";
import RightsAware from '@/lib/mixins/rights-aware';
import CavCavite from '@/lib/models/cav-cavite';
import { State, Getter } from 'vuex-class';
import XInput from '@/components/x-input';
import CavEvtsSurface from '@/lib/models/cav-evts-surface';
import { lexLabel, formatDate } from '@/lib/helpers';
import PanelEvtSurface from '../../components/panel-evt-surface';
import CollectionControl from '@/components/collection-control';
import XTable from '@/components/x-table';
import XTh from '@/components/x-table/x-th';
import ActionTH from '@/components/x-table/action-th';
import ActionTd from '@/components/x-table/action-td';
import XTextarea from '@/components/x-textarea';
import { LexNatureMateriau, LexEtatCaviteEaux } from '@/lib/models/gen-lexs';

@Component
export default class PartSourcesInfos extends Mixins(RightsAware) {

  @Getter getLexique;
  @Getter getLexValue;
  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  get descComplType() {
    if (this.data.typeCavite && /carri.re/g.test(this.data.typeCavite)) {
      return "carriere";
    } else if (this.data.typeCavite && (
      this.data.typeCavite == 'cave'
      || this.data.typeCavite == 'naturelle'
      || /indétermin./g.test(this.data.typeCavite)
      || this.data.typeCavite == 'ouvrage civil'
      || this.data.typeCavite == 'ouv militaire'
    )) {
      return "ouvrageSsT";
    } else {
      return "none";
    }
  }

  @Watch("descComplType", {immediate: true})
  onDescComplTypeChange(v) {
    if (v === "carriere" || v === "none") {
      this.data.profondeurMaxToit = null;
    }
    
    if (v === "ouvrageSsT" || v === "none") {
      this.data.inject({
        profMinToit: null,
        profMaxToit: null,
        hauteurMoy: null,
        nbAcces: null,
        nbmaxSuperposes: null,
        etatCaviteEaux: null
      });
    }
  }

  renderDescComplCarriere() {
    return (
      <div class="field">
        <label class="label is-small">Carrière</label>
        <div class="control">
          <div class="columns">
            <div class="column is-half">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Nature du materiau</label>
                <div class="control">
                  <ListDropdown class="basic"
                    vModel={this.data.precisionMateriau}
                    data={this.getLexique(LexNatureMateriau)}
                    labelFn={lexLabel}
                    transform={v => v.id}
                    prompt="-"/>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Emprise surfacique (m2)</label>
                <div class="control">
                  <XInput vModel={this.data.surfaceEmprise} ofType="integer" class="input is-small"/>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Profondeur min du toit (m)</label>
                <div class="control">
                  <XInput vModel={this.data.profMinToit} ofType="number" class="input is-small"/>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Profondeur max du toit (m)</label>
                <div class="control">
                  <XInput vModel={this.data.profMaxToit} ofType="number" class="input is-small"/>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Hauteur totale moy. de la cavité (m)</label>
                <div class="control">
                  <XInput vModel={this.data.hauteurMoy} ofType="number" class="input is-small"/>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
          <div class="column is-4">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Nombre d'accès</label>
                <div class="control">
                  <XInput vModel={this.data.nbAcces} ofType="integer" class="input is-small"/>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Nombre de niveaux</label>
                <div class="control">
                  <XInput vModel={this.data.nbmaxSuperposes} ofType="integer" class="input is-small"/>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Cavité en eau</label>
                <div class="control">
                  <ListDropdown class="basic"
                    vModel={this.data.etatCaviteEaux}
                    data={this.getLexique(LexEtatCaviteEaux)}
                    labelFn={lexLabel}
                    transform={v => v.libelle}
                    prompt="-"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ); 
  }

  renderDescComplOuvrageSsT() {
    return (
      <div class="field">
        <label class="label is-small">Ouvrage sous terrain</label>
        <div class="control">
          <div class="columns">
            <div class="column is-7">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Nature du materiau</label>
                <div class="control">
                  <ListDropdown class="basic"
                    vModel={this.data.precisionMateriau}
                    data={this.getLexique(LexNatureMateriau)}
                    labelFn={lexLabel}
                    transform={v => v.id}
                    prompt="-"/>
                </div>
              </div>
              <div class="field">
                <label class="label is-small has-text-weight-normal">Profondeur max du toit (m)</label>
                <div class="control">
                  <XInput vModel={this.data.profondeurMaxToit} ofType="number" class="input is-small"/>
                </div>
              </div>
            </div>
            <div class="column is-5">
              <div class="field">
                <label class="label is-small has-text-weight-normal">Emprise surfacique (m²)</label>
                <div class="control">
                  <XInput vModel={this.data.surfaceEmprise} ofType="integer" class="input is-small"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderEvtsSurface() {
    return (
      <CollectionControl
        data={this.data.cavEvtsSurface}
        clazz={PanelEvtSurface}
        scopedSlots={{
          body: ({ data, onEdit, onDelete }) => (
            <XTable data={data}
              class="is-full-width is-bordered is-small"
              scopedSlots={{
                header: () => (
                  <tr>
                    <XTh prop="typeDesordre">Type de désordre</XTh>
                    <XTh prop="dateDebutEvt">Début de l'événement</XTh>
                    <XTh prop="idBdMvt">ID BD MVT</XTh>
                    <ActionTH/>
                  </tr>
                ),
                row: ({d}: {d: CavEvtsSurface}) => (
                  <tr>
                    <td>{lexLabel(this.getLexValue("DesordreSurface", d.typeDesordre), {labelField: "desordresSurface"})}</td>
                    <td>{formatDate(d.dateDebutEvt)}</td>
                    <td>{d.idBdmvt}</td>
                    <ActionTd
                      onEdit={() => onEdit(d)}
                      onDelete={() => onDelete(d)}
                    />
                  </tr>
                )
              }}>
            </XTable>
          )
        }}>
      </CollectionControl>
    )
  }

  render() {
    if (!this.data) { return null };
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-5">
            {{
              carriere: this.renderDescComplCarriere(),
              ouvrageSsT: this.renderDescComplOuvrageSsT(),
              none: null
            }[this.descComplType]}
            <div class="field">
              <label class="label is-small">Commentaire sur la géométrie</label>
              <div class="control">
                <XTextarea vModel={this.data.commentairesGeom} class="textarea is-small" rows={3}/>
              </div>
            </div>
          </div>
          <div class="column is-offset-1">
            <div class="field">
              <label class="label is-small">Événements de surface</label>
              <div class="control">
                {this.renderEvtsSurface()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-58880e7e/desc-compl.tsx" });